export const SupportLink = () => (
  <a
    className="ps-link ps-underline ps-text-blue ps-cursor-pointer"
    href="mailto:support@pepperstone.com"
  >
    support@pepperstone.com
  </a>
);
